import {useEffect} from 'react'
import {Route, Routes, Outlet, Link} from 'react-router-dom'
import {Error500} from './components/Error500'
import {Error404} from './components/Error404'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {WC_AUTH_BG} from '../auth/AuthPage'
import '../auth/auth.scss'

// Error pages share the Onyx auth shell (site photo + warm-charcoal overlay,
// frosted card, white wordmark) so pre-app and error surfaces feel like one UI.
const ErrorsLayout = () => {
  // Paint the document dark behind the fixed viewport so there's no light flash
  // or light gutter on overscroll; restore on unmount.
  useEffect(() => {
    const prevBg = document.body.style.background
    document.body.style.background = '#141310'
    return () => {
      document.body.style.background = prevBg
    }
  }, [])

  return (
    <div className='wc-auth' style={WC_AUTH_BG}>
      <div className='wc-auth__content'>
        <Link to='/'>
          <img
            alt='Web Construct'
            src={toAbsoluteUrl('/media/logos/Web-Construct-Logo-PNG-WHITE.png')}
            className='wc-auth__logo'
          />
        </Link>
        <div className='wc-auth__card'>
          <Outlet />
        </div>
      </div>
      <footer className='wc-auth__footer'>
        © {new Date().getFullYear()} Web Construct
      </footer>
    </div>
  )
}

const ErrorsPage = () => (
  <Routes>
    <Route element={<ErrorsLayout />}>
      <Route path='404' element={<Error404 />} />
      <Route path='500' element={<Error500 />} />
      <Route index element={<Error404 />} />
    </Route>
  </Routes>
)

export {ErrorsPage}
